import PropTypes from 'prop-types'
/**
 * Updates the key of a node in its parent object.
 *
 * @param {Object} props - The props object containing the required parameters.
 * @param {Object} props.root - The root object to search for the node.
 * @param {string} props.oldKey - The old key of the node.
 * @param {string} props.newKey - The new key to assign to the node.
 * @param {Object} props.newNode - The new node object to replace the old node.
 * @returns {void}
 */
const updateNodeKeyInParent = (props) => {
  const { root, oldKey, newKey, newNode } = props

  const searchKey = (obj) => {
    if (obj?.[oldKey]) {
      const object = obj?.[oldKey]
      const {
        _id,
        name,
        translations,
        eNumber,
        synonyms,
        description,
        isIngredient,
        isDeclared,
        isVisibleInRecipes,
        userId,
        productsIds
      } = newNode

      const nodeToBeUpdated = {
        ...object,
        _id,
        name,
        translations,
        eNumber,
        synonyms,
        description,
        isIngredient,
        isDeclared,
        isVisibleInRecipes,
        userId,
        productsIds,
        _path: object?._path
          ?.split('/')
          ?.map((element, index, array) => {
            if (index === array.length - 1) {
              return newKey
            }
            return element
          })
          .join('/'),
        _parentIds: [...(object?._parentIds || [])],
        children: newNode?.children
        // children:
        //   oldKey === object?._id ? newNode?.children : object?.children || []
      }

      obj[newKey] = nodeToBeUpdated
      delete obj?.[oldKey]
    }
    for (const key in obj) {
      if (typeof obj?.[key] === 'object') {
        searchKey(obj?.[key])
      }
    }
  }

  searchKey(root)
}

updateNodeKeyInParent.propTypes = {
  root: PropTypes.object,
  oldKey: PropTypes.string,
  newKey: PropTypes.string,
  newNode: PropTypes.object
}

export default updateNodeKeyInParent
